import { Box } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import * as React from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
interface CustomFlatListProps {
  renderItem: any
  data: any
  renderScrollView: any
  type: number
  setShowPaymentProcessModal: any
  selectedItem: string
  setSelectedItem: any
  showofferInfo: any
  validateOfferState: any
  applyOfferState: any
  onClickPay: () => void
  convFeeComp: React.ReactNode
  amount: string
}

const CustomFlatList = ({
  renderItem,
  data,
  renderScrollView,
  type,
  setShowPaymentProcessModal,
  selectedItem,
  setSelectedItem,
  showofferInfo,
  validateOfferState,
  applyOfferState,
  onClickPay,
  convFeeComp,
  amount,
}: CustomFlatListProps) => {
  console.log('validateOfferState: ', validateOfferState)
  const _renderRecycleView = (_type: any, item: any, index: any) => {
    return renderItem({ item, index })
  }

  useEffect(() => {
    setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
  }, [data])

  const [_dataProvider, setDataProvider] = useState(
    new DataProvider((r1, r2) => {
      return r1 !== r2
    }).cloneWithRows(data),
  )

  const [_layoutProvider] = useState(
    new LayoutProvider(
      () => {
        return 'VSEL'
      },
      (type, dim) => {
        switch (type) {
          case 'VSEL':
            dim.width = Math.round(Dimensions.get('window').width)
            dim.height = 64
            break
        }
      },
    ),
  )

  return (
    <Box f={1}>
      {data && data.length > 0 && (
        <RecyclerListView
          style={{ flex: 1 }}
          dataProvider={_dataProvider}
          scrollViewProps={{
            type,
            setShowPaymentProcessModal,
            selectedItem,
            setSelectedItem,
            showofferInfo,
            validateOfferState,
            applyOfferState,
            onClickPay,
            convFeeComp,
            amount,
          }}
          externalScrollView={renderScrollView}
          rowRenderer={_renderRecycleView}
          layoutProvider={_layoutProvider}
          // validateOfferState={validateOfferState}
          // showofferInfo={showofferInfo}
        />
      )}
    </Box>
  )
}

export { CustomFlatList }
